export default function MissionStatement() {
  return (
    <section className="bg-cream py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">

        {/* Top ornament */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="h-px w-16 bg-amber-300" />
          <div className="w-2 h-2 flex items-center justify-center">
            <span className="block w-2 h-2 rounded-full bg-amber-400" />
          </div>
          <div className="h-px w-16 bg-amber-300" />
        </div>

        {/* Heading */}
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-amber-900 leading-tight mb-10">
          This Is Not a{" "}
          <em className="text-amber-600 italic">Hype Show.</em>
        </h2>

        {/* Body */}
        <p className="font-serif text-xl md:text-2xl text-stone-600 leading-relaxed max-w-3xl mx-auto mb-12" style={{ fontWeight: 400 }}>
          We&apos;re not here to tell you AI will solve every problem on the planet. And we&apos;re definitely not here to scare you. The Humble Machine exists for people who just want to understand what&apos;s happening and how it affects them &mdash; without the noise, without the jargon, and without an agenda.
        </p>

        {/* Closing line — punchy */}
        <div className="relative inline-block">
          <p className="font-serif text-xl md:text-2xl font-semibold text-amber-800 italic tracking-wide">
            We inform. We encourage. We think together.
          </p>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 h-0.5 w-2/3 rounded-full bg-amber-300/70" />
        </div>

        {/* Bottom ornament */}
        <div className="flex items-center justify-center gap-4 mt-16">
          <div className="h-px w-10 bg-amber-200" />
          <div className="w-1.5 h-1.5 flex items-center justify-center">
            <span className="block w-1.5 h-1.5 rounded-full bg-amber-300" />
          </div>
          <div className="h-px w-10 bg-amber-200" />
        </div>

      </div>
    </section>
  );
}
